<template>
	<article class="tregister-general">
		<section class="tregister__section tregister__personal-info">
			<fieldset>
				<legend>Información Personal</legend>
				<div class="tregister__wrap">
					<!-- tipo de documento -->
					<md-field>
						<label for="documentType">Tipo de Documento</label>
						<md-select v-model="ldata.documentType" name="documento" id="documento" placeholder="Tipo de Documento"
							required>
							<md-option value="01">DNI</md-option>
							<md-option value="04">CARNÉ DE EXTRANJERÍA</md-option>
							<md-option value="07">PASAPORTE</md-option>
							<md-option value="23">PTP</md-option>
						</md-select>
					</md-field>

					<!-- numero de documento -->
					<md-field>
						<label>Número Documento</label>
						<md-input name="nroDocumento" id="nroDocumento" v-model="ldata.documentNumber" required></md-input>
						<!-- <span class="md-error" v-if="!$v.ldata.documentNumber.required"
              >Número de documento es requerido</span
            >
            <span class="md-error" v-if="!$v.ldata.documentNumber.numeric"
              >Documento no válido</span
            > -->
					</md-field>

					<!-- nombres -->
					<md-field>
						<label>Nombres</label>
						<md-input name="nombre" id="nombre" v-model="ldata.firstName" required></md-input>
						<!-- <span class="md-error" v-if="!$v.ldata.firstName.required"
              >Nombres son requeridos</span
            >
            <span class="md-error" v-if="!$v.ldata.firstName.isAlpha"
              >Nombre no válido</span
            > -->
					</md-field>

					<!-- apellido paterno -->
					<md-field>
						<label>Apellido Paterno</label>
						<md-input name="apPaterno" id="apPaterno" v-model="ldata.firstSurname" required></md-input>
						<!-- <span class="md-error" v-if="!$v.ldata.firstSurname.required"
              >Apellido paterno es requerido</span
            >
            <span class="md-error" v-if="!$v.ldata.firstSurname.isAlpha"
              >Campo requiere solo letras</span
            > -->
					</md-field>

					<!-- apellido materno -->
					<md-field>
						<label>Apellido Materno</label>
						<md-input name="apMaterno" id="apMaterno" v-model="ldata.secondSurname" required></md-input>
						<!-- <span class="md-error" v-if="!$v.ldata.secondSurname.required"
              >Apellido materno es requerido</span
            >
            <span class="md-error" v-if="!$v.ldata.secondSurname.isAlpha"
              >Campo requiere solo letras</span
            > -->
					</md-field>

					<!-- apellido casada -->
					<md-field v-if="ldata.gender == 'female'">
						<label>Apellido Casada</label>
						<md-input name="apCasada" id="apCasada" v-model="ldata.marriedSurname"></md-input>
						<!-- <span class="md-error" v-if="!$v.ldata.marriedSurname.isAlpha"
              >Campo requiere solo letras</span
            > -->
					</md-field>

					<!-- fecha de nacimiento -->
					<md-field>
						<label>Fecha de Nacimiento</label>
						<v-date-picker v-model="dateBorn" class="datepick" popover-visibility="focus" :max-date="maxBornDate">
							<md-input slot-scope="{ inputValue }" style="text-align: left !important" :value="inputValue"
								readonly></md-input>
						</v-date-picker>
					</md-field>

					<!-- número telefónico -->
					<md-field>
						<label>Número telefónico</label>
						<md-input name="phone" id="phone" v-model="ldata.phone" required></md-input>
						<!-- <span class="md-error" v-if="!$v.ldata.phone.required"
              >Número telefónico es requerido</span
            >
            <span class="md-error" v-if="!$v.ldata.phone.isPhone"
              >Número telefónico no válido</span
            > -->
					</md-field>

					<!-- correo electronico -->
					<md-field>
						<label>Correo Electrónico</label>
						<md-input name="correoE" id="correoE" v-model="ldata.email" required></md-input>
						<!-- <span class="md-error" v-if="!$v.ldata.email.required"
              >Correo electrónico es requerido</span
            >
            <span class="md-error" v-if="!$v.ldata.email.email"
              >Correo electrónico no válido</span
            > -->
					</md-field>

					<!-- género -->
					<div class="field-radio">
						<div class="field-radio__label">Sexo</div>
						<md-radio v-model="ldata.gender" value="male">Masculino</md-radio>
						<md-radio v-model="ldata.gender" value="female">Femenino</md-radio>
					</div>
				</div>
			</fieldset>
		</section>
		<section class="tregister__section tregister__address-info">
			<fieldset>
				<legend>Información de domicilio</legend>
				<div class="tregister__wrap">
					<md-field>
						<label for="pais">País</label>
						<md-select v-model="ldata.country" name="pais" id="pais" placeholder="País" required>
							<md-option value="peru">Perú</md-option>
						</md-select>
					</md-field>

					<md-field>
						<label for="departamento">Departamento/Región</label>
						<md-select v-model="regionModal" name="departamento" id="departamento" placeholder="Departamento" required
							@md-selected="getProvinces">
							<md-option :value="region.id" v-for="(region, $index) in regiones" :key="`region-${$index}`">{{ region.name
							}}</md-option>
						</md-select>
					</md-field>

					<md-field>
						<label for="provincia">Provincia</label>
						<md-select v-model="provinciaModal" name="provincia" id="provincia" placeholder="Provincia" required
							@md-selected="getDistritos">
							<md-option :value="provincia.id" v-for="(provincia, $index) in provincias" :key="`provincia-${$index}`">{{
								provincia.name }}</md-option>
						</md-select>
					</md-field>

					<md-field>
						<label for="distrito">Distrito</label>
						<md-select v-model="ldata.district" name="distrito" id="distrito" placeholder="Distrito" required>
							<md-option :value="distrito.id" v-for="(distrito, $index) in distritos" :key="`distrito-${$index}`">{{
								distrito.name }}</md-option>
						</md-select>
					</md-field>

					<md-field class="direccion">
						<label>Zona Domicilio</label>
						<md-input name="zonaDomicilio" id="zonaDomicilio" v-model="direccion" required
							style="text-transform: capitalize" @click="showDirectionModal = true"></md-input>
					</md-field>

					<md-dialog :md-active.sync="showDirectionModal" :md-click-outside-to-close="true">
						<md-dialog-title>Dirección</md-dialog-title>
						<div class="container-md">
							<md-autocomplete v-model="roadType" :md-options="roadTypes" md-input-id="roadtype" md-dense
								@md-selected="selectVia" required class="buscador">
								<label>Tipo de Vía</label>
								<template slot="md-autocomplete-item" slot-scope="{ item }">
									{{ item.name }}
								</template>
							</md-autocomplete>

							<md-field>
								<label>Nombre de vía</label>
								<md-input v-model="ldata.address.roadName"></md-input>
							</md-field>

							<md-autocomplete v-model="zoneType" :md-options="zoneTypes" md-input-id="zonetype" md-dense
								@md-selected="selectZone" required class="buscador">
								<label>Tipo de Zona</label>
								<template slot="md-autocomplete-item" slot-scope="{ item }">
									{{ item.name }}
								</template>
							</md-autocomplete>

							<md-field>
								<label>Nombre de Zona</label>
								<md-input v-model="ldata.address.zoneName"></md-input>
							</md-field>

							<div class="container-md__group">
								<md-field>
									<label>Nro vía</label>
									<md-input v-model="ldata.address.roadNumber"></md-input>
								</md-field>
								<md-field>
									<label>Bloque</label>
									<md-input v-model="ldata.address.block"></md-input>
								</md-field>
								<md-field>
									<label>Dpto</label>
									<md-input v-model="ldata.address.flat"></md-input>
								</md-field>
								<md-field>
									<label>Interior</label>
									<md-input v-model="ldata.address.interior"></md-input>
								</md-field>
								<md-field>
									<label>Manzana</label>
									<md-input v-model="ldata.address.square"></md-input>
								</md-field>
								<md-field>
									<label>Lote</label>
									<md-input v-model="ldata.address.lot"></md-input>
								</md-field>
								<md-field>
									<label>Kilómetro</label>
									<md-input v-model="ldata.address.km"></md-input>
								</md-field>
								<md-field>
									<label>Etapa</label>
									<md-input v-model="ldata.address.stage"></md-input>
								</md-field>
								<md-field>
									<label>Ubigeo</label>
									<md-input v-model="ldata.address.ubigeo"></md-input>
								</md-field>
							</div>
						</div>
						<md-dialog-actions>
							<md-button class="md-accent" @click="showDirectionModal = false">Cerrar</md-button>
							<md-button class="md-primary" @click="loadDirection()">Guardar</md-button>
						</md-dialog-actions>
					</md-dialog>
				</div>
			</fieldset>
		</section>
		<section class="tregister__section tregister__laboral-info">
			<fieldset>
				<legend>Información Laboral</legend>
				<div class="tregister__wrap">
					<md-field>
						<label>Fecha de Ingreso</label>
						<v-date-picker v-model="dateInit" class="datepick" popover-visibility="focus">
							<md-input slot-scope="{ inputProps, inputEvents, inputValue }" style="text-align: left !important"
								v-bind="inputProps" v-on="inputEvents" readonly :value="inputValue"></md-input>
						</v-date-picker>
					</md-field>

					<md-field>
						<label for="regLab">Régimen Laboral</label>
						<md-select v-model="ldata.laborRegime" name="regimen" id="regimen" required>
							<md-option value="01">General - D LEG No 728</md-option>
							<md-option value="16">Microempresa - D LEG No 1086</md-option>
							<md-option value="17">Pequeña Empresa - D LEG No 1086</md-option>
						</md-select>
					</md-field>

					<md-field>
						<label for="tipoContrato">Tipo de Contrato</label>
						<md-select v-model="ldata.contractType" name="contrato" id="contrato" required>
							<md-option value="01">Plazo Indeterminado</md-option>
							<md-option value="02">Tiempo Parcial</md-option>
							<md-option value="03">Por Inicio o Incremento de Actividad</md-option>
							<md-option value="04">Por Necesidad de Mercado</md-option>
							<md-option value="07">De Suplencia</md-option>
							<md-option value="13">Trabajador Extranjero</md-option>
							<md-option value="14">Administrativo de Servicios</md-option>
							<md-option value="06">Contrato Ocasional</md-option>
						</md-select>
					</md-field>

					<md-field>
						<label for="tipoTrabaj">Tipo de Trabajador</label>
						<md-select v-model="ldata.workerType" name="regimen" id="regimen" required>
							<md-option value="19">EJECUTIVO</md-option>
							<md-option value="20">OBRERO</md-option>
							<md-option value="21">EMPLEADO</md-option>
							<md-option value="27">CONSTRUCCIÓN CIVIL</md-option>
						</md-select>
					</md-field>

					<md-field>
						<label for="jornLab">Jornada Laboral</label>
						<md-select v-model="ldata.workdayType" name="jornada" id="jornada" required>
							<md-option value="1">Jornada de trabajo máxima</md-option>
							<md-option value="2">Jornada atípica o acumulativa</md-option>
							<md-option value="3">Trabajo en horario nocturno</md-option>
						</md-select>
					</md-field>

					<md-autocomplete v-model="ldata.occupationLabel" :md-options="occupationsComp" md-input-id="buscador" md-dense
						:md-open-on-focus="false" @input.native="searchOccupation($event.target.value)"
						@md-selected="selectOccupation" required class="buscador-empleo">
						<label>Ocupación</label>
						<template slot="md-autocomplete-item" slot-scope="{ item }">
							{{ item.name }}
						</template>
					</md-autocomplete>

					<md-field>
						<label for="charge">Cargo</label>
						<md-input name="charge" id="charge" v-model="ldata.professionalPosition"></md-input>
					</md-field>

					<md-field>
						<label for="payment">Tipo de Pago</label>
						<md-select v-model="ldata.paymentType" name="payment" id="payment" required>
							<md-option value="1">Efectivo</md-option>
							<md-option value="2">Depósito</md-option>
						</md-select>
					</md-field>

					<md-field>
						<label for="paymentPeriod">Periodicidad</label>
						<md-select v-model="ldata.periodicityPayment" name="paymentPeriod" id="paymentPeriod" required>
							<md-option value="1">Mensual</md-option>
							<md-option value="2">Quincenal</md-option>
							<md-option value="3">Semanal</md-option>
							<md-option value="4">Diario</md-option>
						</md-select>
					</md-field>

					<md-field>
						<label>Sueldo Bruto</label>
						<span class="md-prefix">S/.</span>
						<md-input name="sueldoBruto" id="sueldoBruto" v-model.number="ldata.grossSalary" required></md-input>
						<span class="md-error" v-if="!$v.ldata.grossSalary.required">Sueldo bruto es requerido</span>
						<span class="md-error" v-if="!$v.ldata.grossSalary.decimal">Sueldo no válido</span>
					</md-field>

					<div class="field-radio">
						<div class="field-radio__label">Es RIA</div>
						<md-checkbox v-model="ldata.isRIA">Ría</md-checkbox>
					</div>

					<md-field v-if="ldata.paymentType == '2'">
						<label>Banco a Depositar</label>
						<md-input name="nombreBanco" id="nombreBanco" v-model="ldata.bankName" required></md-input>
					</md-field>
					<md-field v-if="ldata.paymentType == '2'">
						<label>Número Cuenta</label>
						<md-input name="nroCuenta" id="nroCuenta" v-model="ldata.bankAccount" required></md-input>
						<span class="md-error" v-if="!$v.ldata.bankAccount.required">Número de cuenta es requerido</span>
						<span class="md-error" v-if="!$v.ldata.bankAccount.numeric">Número no válido</span>
					</md-field>
					<md-field>
						<label>Banco a Depositar CTS</label>
						<md-input name="nombreBancoCts" id="nombreBancoCts" v-model="ldata.bankNameCts"></md-input>
					</md-field>
					<md-field>
						<label>Número Cuenta para CTS</label>
						<md-input name="nroCuentaCts" id="nroCuentaCts" v-model="ldata.bankAccountCts"></md-input>
					</md-field>
					<md-field>
						<label>Horas Contrato</label>
						<span class="md-prefix">⌛</span>
						<md-input v-model.number="ldata.contractualHours" required></md-input>
						<span class="md-error" v-if="!$v.ldata.contractualHours.required">Horas contrato es requerido</span>
						<span class="md-error" v-if="!$v.ldata.contractualHours.hourLaboral">Horas no válidas</span>
					</md-field>

					<div class="field-radio">
						<div class="field-radio__label">Sindicalizado</div>
						<md-radio v-model="ldata.unionized" :value="true">Sí</md-radio>
						<md-radio v-model="ldata.unionized" :value="false">No</md-radio>
					</div>

					<div class="field-radio">
						<div class="field-radio__label">Discapacitado</div>
						<md-radio v-model="ldata.personWithDisability" :value="true">Sí</md-radio>
						<md-radio v-model="ldata.personWithDisability" :value="false">No</md-radio>
					</div>
				</div>
			</fieldset>
		</section>
		<section class="tregister__section tregister__social-security-info">
			<fieldset>
				<legend>Seguridad Social</legend>
				<div class="tregister__wrap">
					<md-field>
						<label for="regsalud">Régimen de Salud</label>
						<md-select v-model="ldata.healthRegime" name="regsalud" id="regsalud" @md-selected="selectRegSalud" required>
							<md-option value="00">EsSalud Regular(Exclusivo)</md-option>
							<md-option value="01">EsSalud Regular Y EPS/Serv. Prop.</md-option>
							<md-option value="05">EsSalud Pensionistas</md-option>
							<md-option value="20">Sanidad FFAA y Policiales</md-option>
							<md-option value="21">SIS - Microempresa</md-option>
						</md-select>
					</md-field>

					<!-- prestadora de salud -->
					<md-field v-if="ldata.healthRegime == '01'">
						<label for="presalud">Prestadora de salud</label>
						<md-select v-model="ldata.eps" name="presalud" id="presalud" required>
							<md-option value="02">Pacífico</md-option>
							<md-option value="03">Rímac Internacional</md-option>
							<md-option value="04">Servicios propios</md-option>
							<md-option value="05">Mapfre Perú</md-option>
							<md-option value="06">Sanitas Perú</md-option>
							<md-option value="07">La Positiva</md-option>
						</md-select>
					</md-field>

					<!-- regimen Pensionario -->
					<md-field>
						<label for="regPens">Régimen Pensionario</label>
						<md-select v-model="ldata.pensionSystem" name="regpens" id="regpens" @md-selected="selectRegPen" required>
							<md-option value="02">ONP Sistema Nacional de Pensiones</md-option>
							<md-option value="21">SPP Integra</md-option>
							<!-- <md-option value="22">SPP Horizonte</md-option> -->
							<md-option value="23">SPP ProFuturo</md-option>
							<md-option value="24">SPP Prima</md-option>
							<md-option value="25">SPP Habitat</md-option>
							<md-option value="-1">SIN SIST. DE PENSION</md-option>
						</md-select>
					</md-field>

					<!-- codigo cuspp -->
					<md-field v-if="ldata.pensionSystem &&
						ldata.pensionSystem != '02' &&
						ldata.pensionSystem != '-1'
						">
						<label>Código CUSPP</label>
						<md-input name="cuspCode" id="cuspCode" v-model="ldata.cuspCode"></md-input>
						<!-- <span class="md-error" v-if="!$v.ldata.cuspCode.alphaNum"
          >Código ingresado no válido</span
        > -->
					</md-field>

					<!-- tipo d comision -->
					<md-field v-if="ldata.pensionSystem &&
						ldata.pensionSystem != '02' &&
						ldata.pensionSystem != '-1'
						">
						<label for="comType">Tipo de comisión</label>
						<md-select v-model="ldata.pensionSystemType" name="comtype" id="comtype" required>
							<md-option value="01">Flujo</md-option>
							<md-option value="02">Mixta/Flujo</md-option>
							<!-- <md-option value="03">Mixta/Saldo</md-option> -->
						</md-select>
					</md-field>
				</div>
			</fieldset>
		</section>
		<section class="tregister__section tregister__aditional-info">
			<fieldset>
				<legend>Información Adicional</legend>
				<div class="tregister__wrap c-emergencia__wrapper">
					<md-subheader>Rentas de quinta categoría</md-subheader>

					<!-- remuneracion anterior -->
					<md-field>
						<label>Remuneración anterior</label>
						<span class="md-prefix">S/.</span>
						<md-input name="rem" id="rem" v-model.number="ldata.totalPrevRemunerations" required></md-input>
						<!-- <span class="md-error" v-if="!$v.ldata.totalPrevRemunerations.numeric">Campo debe ser numérico</span> -->
					</md-field>

					<!-- retencion anterior -->
					<md-field class="getValidationClass($v.ldata.totalOtherRetentions)">
						<label>Retención anterior</label>
						<span class="md-prefix">S/.</span>
						<md-input name="ret" id="ret" v-model.number="ldata.totalPrevRetentions" required></md-input>
						<!-- <span class="md-error" v-if="!$v.ldata.totalPrevRetentions.numeric">Campo debe ser numérico</span> -->
					</md-field>

					<md-subheader>En caso de emergencia</md-subheader>

					<!-- codigo cuspp -->
					<md-field>
						<label>Vínculo Familiar</label>
						<md-input name="vinculo" id="vinculo" v-model="ldata.kinshipType" required></md-input>
						<!-- <span class="md-error" v-if="!$v.ldata.kinshipType.alpha">Campo requiere solo letras</span> -->
					</md-field>

					<!-- nombres -->
					<md-field>
						<label>Nombres</label>
						<md-input name="nombres" id="nombres" v-model="ldata.contactFirstName" required></md-input>
						<!-- <span class="md-error" v-if="!$v.ldata.contactFirstName.isAlpha">Campo requiere solo letras</span> -->
					</md-field>

					<!-- apellido paterno -->
					<md-field>
						<label>Apellido Paterno</label>
						<md-input name="apPaternoEmergency" id="apPaternoEmergency" v-model="ldata.contactFirstSurname"
							required></md-input>
						<!-- <span class="md-error" v-if="!$v.ldata.contactFirstSurname.isAlpha">Campo requiere solo letras</span> -->
					</md-field>

					<!-- apellido materno -->
					<md-field>
						<label>Apellido Materno</label>
						<md-input name="apMaternoEmergency" id="apMaternoEmergency" v-model="ldata.contactSecondSurname"
							required></md-input>
						<!-- <span class="md-error" v-if="!$v.ldata.contactSecondSurname.isAlpha">Campo requiere solo letras</span> -->
					</md-field>

					<!-- numero telefono -->
					<md-field>
						<label>Número Teléfono</label>
						<md-input name="numTelf" id="numTelf" v-model="ldata.contactTelephone"></md-input>
						<!-- <span class="md-error" v-if="!$v.ldata.contactTelephone.numeric">Campo requiere solo números</span> -->
					</md-field>

					<!-- numero celular -->
					<md-field>
						<label>Número Celular</label>
						<md-input name="numCel" id="numCel" v-model="ldata.contactCellphone" required></md-input>
						<!-- <span class="md-error" v-if="!$v.ldata.contactCellphone.isPhone">Números de celular incorrecto</span> -->
					</md-field>
				</div>
			</fieldset>
		</section>
		<section class="tregister__section tregister__actions" v-if="show">
			<md-button class="md-primary" @click="$emit('close-modal')">Cancelar</md-button>
			<md-button class="md-primary md-raised" @click="saveData">Guardar</md-button>
		</section>
	</article>
</template>

<script>
const Ubigeoperu = require("peru-ubigeo");
var ubigeo = new Ubigeoperu();
import { mapActions } from "vuex";
import { validationMixin } from "vuelidate";
import {
	required,
	email,
	numeric,
	helpers,
	decimal,
} from "vuelidate/lib/validators";
const isAlpha = helpers.regex("alpha", /^[a-zA-ZÀ-ÿñÑ ]*$/);
const isPhone = helpers.regex("numeric", /^9[0-9]{8}$/);
const hourLaboral = helpers.regex("numeric", /^(?:[1-9])$/);
export default {
	name: "TregisterGeneral",
	mixins: [validationMixin],
	props: {
		value: Object,
		isHistoric: Boolean,
		historicId: String,
	},
	data() {
		return {
			ldata: {
				occupation: {
					name: "",
					code: "",
				},
				address: {
					roadType: "",
					roadName: "",
					roadNumber: "",
					flat: "",
					interior: "",
					square: "",
					lot: "",
					km: "",
					block: "",
					stage: "",
					zoneType: "",
					zoneName: "",
					reference: "",
					ubigeo: "",
				},
			},
			roadType: null,
			roadTypes: [
				{ code: "01", label: "Av", name: "Avenida" },
				{ code: "02", label: "Jr", name: "Jirón" },
				{ code: "03", label: "Ca", name: "Calle" },
				{ code: "04", label: "Pje", name: "Pasaje" },
				{ code: "05", label: "Al", name: "Alameda" },
				{ code: "06", label: "Ml", name: "Malecón" },
				{ code: "07", label: "Ov", name: "Óvalo" },
				{ code: "08", label: "Pq", name: "Parque" },
				{ code: "09", label: "Pl", name: "Plaza" },
				{ code: "10", label: "Cr", name: "Carretera" },
				{ code: "14", label: "Cm", name: "Camino Rural" },
				{ code: "15", label: "Ba", name: "Bajada" },
				{ code: "16", label: "Ga", name: "Galería" },
				{ code: "17", label: "Pr", name: "Prolongación" },
				{ code: "18", label: "Pas", name: "Paseo" },
				{ code: "19", label: "Pz", name: "Plazuela" },
				{ code: "99", label: "Vía", name: "Otro" },
			],
			zoneType: null,
			zoneTypes: [
				{ code: "01", label: "URB.", name: "Urbanización" },
				{ code: "02", label: "P.J.", name: "Pueblo Joven" },
				{ code: "03", label: "U.V.", name: "Unidad Vecinal" },
				{ code: "04", label: "C.H.", name: "Conjunto Habitacional" },
				{ code: "05", label: "A.H.", name: "Asentamiento Humano" },
				{ code: "06", label: "COO.", name: "Cooperativa" },
				{ code: "07", label: "RES.", name: "Residencial" },
				{ code: "08", label: "Z.I.", name: "Zona Industrial" },
				{ code: "09", label: "GRU.", name: "Grupo" },
				{ code: "10", label: "CAS.", name: "Caserío" },
				{ code: "11", label: "FND.", name: "Fundo" },
				{ code: "99", label: "Zona", name: "Otros" },
			],
			direccion: null,
			occupations: [],

			//principal
			nombres: null,
			apPaterno: null,
			apMaterno: null,
			apCasada: null,
			correoE: null,
			documentType: "dni",
			nroDocumento: null,
			// dateBorn: null,
			sexo: "mujer",
			// tipoSangre: "o+",

			//direccion
			// pais: "peru",
			// departamento: "lima",
			// provincia: "lima",
			// distrito: "cercado",
			zonaDomicilio: null,
			dirReniec: true,
			dirDomicilio: null,
			ubigeo: null,
			regiones: [],
			regionModal: null,
			provincias: [],
			provinciaModal: null,
			distritos: [],
			distritoModal: null,
			//laboral
			// dateInit: null,
			inputValueInit: null,
			regLab: "pequena",
			tipoContrato: "indet",
			tipoTrabaj: "empleado",
			jornLab: "trabajoMax",
			ocupacion: "gerGral",
			sueldoBruto: null,
			nroCuenta: null,
			bankName: null,
			sindicalizado: true,
			discapacitado: false,
			hasGratification: false,
			gratificationType: null,
			hasCts: false,
			ctsType: null,
			hasFamilyAssignment: false,
			currentView: "Principal",
			professionalPosition: null,
			//show Direction Modal
			showDirectionModal: false,
			//direction
			typeVia: null,
			viaName: null,
			nVia: null,
			block: null,
			int: null,
			dpto: null,
			mza: null,
			lote: null,
			km: null,
			//laboral
			typePayment: null,
			paymentPeriod: null,
			healthRegime: null,
			pensionSystem: null,
			cuspCode: null,
			entSalud: null,
		};
	},
	computed: {
		occupationsComp() {
			return this.occupations;
		},
		dateInit: {
			get() {
				if (!this.ldata.admittedAt) return new Date();
				console.log(this.ldata.admittedAt);
				return new Date(this.ldata.admittedAt);
			},
			set(value) {
				console.log(value);
				this.setInitDate(value);
			},
		},
		dateBorn: {
			get() {
				// if(!this.ldata.bornDate)
				//   return this.maxBornDate
				return new Date(this.ldata.bornDate);
			},
			set(value) {
				this.setBornDate({ date: value });
			},
		},
		maxBornDate() {
			return new Date(
				new Date().getFullYear() - 18,
				new Date().getMonth(),
				new Date().getDate()
			);
		},
		stateLocal() {
			let stateLocal;
			switch (this.$route.name) {
				case "trDrafts":
					stateLocal = "drafts";
					break;
				case "trForEmployee":
					stateLocal = "foremployee";
					break;
				case "trHasEmployee":
					stateLocal = "hasemployee";
					break;
				case "trDown":
					stateLocal = "getdown";
					break;
			}
			return stateLocal;
		},
		show() {
			return ["owner", "master", "manager", "normal"].includes(this.$store.getters.roleIn);
		}
	},
	validations: {
		nombres: { required, isAlpha },
		apPaterno: { required, isAlpha },
		apMaterno: { required, isAlpha },
		apCasada: { isAlpha },
		correoE: { email, required },
		nroDocumento: { numeric, required },

		zonaDomicilio: { required },
		dirDomicilio: { required },

		sueldoBruto: { numeric, required },
		nroCuenta: { numeric, required },
		ldata: {
			documentNumber: { numeric, required },
			firstName: { required, isAlpha },
			firstSurname: { required, isAlpha },
			secondSurname: { required, isAlpha },
			marriedSurname: { isAlpha },
			email: { email, required },
			// address: {required},
			grossSalary: { decimal, required },
			bankAccount: { numeric, required },
			backName: { required, isAlpha },
			phone: { required, isPhone },
			contractualHours: { required, hourLaboral },
		},
	},
	created() {
		this.searchOccupation();
		this.regiones = ubigeo.getRegions();
		if (this.value && this.value.id) {
			console.log("check to populate ldata ", this.value.id);
			this.ldata = { ...this.ldata, ...this.value };
			if (this.ldata.department) {
				this.regiones = ubigeo.getRegions();
				this.regionModal = this.ldata.department;
				this.provincias = this.regiones
					.find((r) => r.id == this.regionModal)
					.provinces();
			}
			if (this.ldata.province) {
				this.provinciaModal = this.ldata.province;
				this.distritos = this.provincias.find(
					(p) => p.id == this.provinciaModal
				);
			}

			if (this.ldata.district) {
				this.distritoModal = this.ldata.district;
			}
			if (this.ldata.address.roadType) {
				this.roadType = this.roadTypes.filter(
					(item) => item.code == this.ldata.address.roadType
				)[0].name;
			}

			if (this.ldata.address.zoneType) {
				this.zoneType = this.zoneTypes.filter(
					(item) => item.code == this.ldata.address.zoneType
				)[0].name;
			}

			if (this.ldata.address.roadType && this.ldata.address.zoneType) {
				this.loadDirection();
			}
		}
	},
	methods: {
		...mapActions({
			updateTRegister: "updateTRegister",
			getOccupations: "getOccupations",
			getTRegisters: "getTRegisters",
		}),
		selectOccupation(item) {
			// console.log("el item: ",item)
			console.log(this.ldata);
			this.ldata.occupationLabel = item.name;
			this.ldata.occupation.name = item.name;
			// (this.ldata.occupation.name = this.ldata.occupationLabel = item.name);
			this.ldata.occupation.code = item.code;
		},
		loadDirection() {
			this.direccion = [
				this.roadTypes.filter((item) => item.name == this.roadType)[0].label,
				this.ldata.address.roadName,
				"Nro " + this.ldata.address.roadNumber,
				"Bloque " + this.ldata.address.block,
				"Dpto " + this.ldata.address.flat,
				"Int " + this.ldata.address.interior,
				"Mza " + this.ldata.address.square,
				"Lote " + this.ldata.address.lot,
				"Km " + this.ldata.address.km,
				this.zoneTypes.filter((item) => item.name == this.zoneType)[0].label,
				this.ldata.address.zoneName,
				"Etapa " + this.ldata.address.stage,
			]
				.filter((r) => r[r.length - 1] != " ")
				.join(" ");

			this.showDirectionModal = false;
		},
		searchOccupation($e = "") {
			// console.log($e);

			this.getOccupations($e).then((r) => {
				if (r.status == 200) {
					console.log(r.data);
					// console.log('resu:', r)
					this.occupations = r.data.results;
				}
			});
		},
		selectVia(value) {
			this.roadType = value.name;
			this.ldata.address.roadType = value.code;
		},

		selectZone(value) {
			this.zoneType = value.name;
			this.ldata.address.zoneType = value.code;
		},
		getProvinces() {
			// console.log(this.regionModal);
			this.ldata.department = this.regionModal;
			this.provincias = this.regiones
				.find((r) => r.id == this.regionModal)
				.provinces();
			// console.log(this.provincias);
		},
		getDistritos() {
			// console.log(this.provinciaModal);
			this.ldata.province = this.provinciaModal;
			this.distritos = this.provincias
				.find((p) => p.id == this.provinciaModal)
				.districts();
			// console.log(this.distritos);
		},
		setInitDate(value) {
			console.log(value);
			// this.ldata.admittedAt = new Date(value);
			this.$set(this.ldata, "admittedAt", new Date(value).toISOString());
			console.log(this.ldata.admittedAt);
		},
		setBornDate(value) {
			console.log(value);
			this.$set(this.ldata, "bornDate", new Date(value.date).toISOString());
			// this.ldata.bornDate = value.date.toISOString();
			console.log(this.ldata.bornDate);
		},
		async saveData() {
			let res, message;
			// this.$v.$touch();
			// console
			// if(!this.$v.$invalid){
			//   console.log("cambio de esatdo")
			//   this.$set(this.ldata, 'state', 'foremployee')
			// }
			if (!this.isHistoric) {
				res = await this.updateTRegister({
					id: this.value.id,
					body: this.ldata,
				});
				message = "T-registro actualizado";
			} else {
				res = await this.$store.dispatch("updateTregistersHistoric", {
					id: this.$store.state.business.currentTRegister,
					fk: this.historicId,
					body: this.ldata,
				});
				message = "T-registro Historico actualizado";
			}
			if (res.status === 200) {
				this.$toasted.success(message, {
					theme: "bubble",
					position: "top-right",
					duration: 1000,
					className: "short-message",
				});
				await this.getTRegisters({
					id: this.$localStorage.get("businessID"),
					state: this.stateLocal,
					page: 1,
				});
				this.$emit("close-modal");
			}
		},
		selectRegSalud() {
			if (this.ldata.healthRegime != "01" && this.ldata.eps)
				delete this.ldata.eps;
		},

		selectRegPen() {
			if (this.ldata.pensionSystem == "02" && this.ldata.cuspCode)
				delete this.ldata.cuspCode;
			if (this.ldata.pensionSystem == "02" && this.ldata.pensionSystemType)
				delete this.ldata.pensionSystemType;
		},
	},
	watch: {
		value(newValue) {
			this.ldata = { ...this.ldata, ...newValue };
			if (this.ldata.department) {
				this.regiones = ubigeo.getRegions();
				this.regionModal = this.ldata.department;
				this.provincias = this.regiones
					.find((r) => r.id == this.regionModal)
					.provinces();
			}
			if (this.ldata.province) {
				this.provinciaModal = this.ldata.province;
				this.distritos = this.provincias.find(
					(p) => p.id == this.provinciaModal
				);
			}

			if (this.ldata.district) {
				this.distritoModal = this.ldata.district;
			}
			if (this.ldata.address.roadType) {
				this.roadType = this.roadTypes.filter(
					(item) => item.code == this.ldata.address.roadType
				)[0].name;
			}

			if (this.ldata.address.zoneType) {
				this.zoneType = this.zoneTypes.filter(
					(item) => item.code == this.ldata.address.zoneType
				)[0].name;
			}

			if (this.ldata.address.roadType && this.ldata.address.zoneType) {
				this.loadDirection();
			}
		},
	},
};
</script>

<style lang="scss" scoped>
@mixin mq($min-width) {
	@media screen and (min-width: $min-width) {
		@content;
	}
}

$b-orange: #d8ff00;
$b-blue: #000000;
$b-emph: #97c2c9;
$b-blue-dark: #C63832;
//breakpoints
$sm: 600px;
$md: 900px;
$lg: 1200px;
$xl: 1800px;

.field-radio {
	// margin: 0 2rem 1rem 24px;
	width: 18rem;
	padding-top: 16px;
	position: relative;

	&__label {
		position: absolute;
		top: 0;
		font-size: 12px;
		color: rgba($b-blue, 0.6);
	}
}

//datepicker
.datepick {
	border-bottom: 1px solid #d7dae2;

	&__input {
		font-size: 16px;
		color: rgba(#000, 0.87);

		&::placeholder {
			color: rgba($b-blue, 0.6);
		}
	}

	input[type="text"] {
		font-size: 16px;
		color: rgba(#000, 0.87);

		&::placeholder {
			color: rgba($b-blue, 0.6);
		}
	}
}

//vue-material
.md-field {
	width: 18rem;
	margin: 4px 0 18px;

	&.md-theme-default {
		label {
			color: rgba($b-blue, 0.6);

			&::after {
				color: $b-orange;
			}
		}

		&::after {
			background-color: #d7dae2;
		}

		&::before {
			background-color: $b-blue;
		}

		&.md-focused {
			label {
				color: $b-blue-dark;
			}
		}

		&.md-invalid {
			label {
				color: $b-orange;
			}

			&::after {
				background-color: $b-orange;
			}

			.md-error {
				color: $b-orange;
			}
		}
	}
}

.tregister-general {
	padding: 2rem;

	fieldset {
		padding: 1rem;
	}
}

.tregister {
	&__section {
		margin-bottom: 1rem;
	}

	&__wrap {
		position: relative;
		display: flex;
		flex-wrap: wrap;
		flex-direction: column;
		align-items: center;

		@include mq($md) {
			display: flex;
			flex-direction: row;
			flex-wrap: wrap;
			justify-content: space-between;
		}
	}
}

.md-dialog {
	z-index: 900;
	padding: 1rem 3rem;
	max-width: 30rem;

	@include mq($sm) {
		height: 45rem;
		max-height: 46rem;
	}
}

.container-md {
	display: flex;
	flex-wrap: wrap;

	@include mq($md) {}

	&__group {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;

		@include mq($md) {
			// width: 100%;
		}

		.md-field {
			width: 6rem;
			margin-right: 1rem;

			@include mq($md) {
				width: 6rem;
			}
		}
	}
}

.direccion {
	@include mq($md) {
		width: 30rem;
	}
}

.c-emergencia__wrapper {
	position: relative;

	@include mq($md) {
		display: flex;
		flex-wrap: wrap;
		// justify-content: center;
		// margin-top: 6rem;
	}

	.md-subheader {
		width: 100%;
		color: $b-blue-dark !important;
	}
}
</style>
